import React from 'react';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

/**
 * 로그인 페이지 버튼들
 * @typedef {Object} props
 * @param {string} onLogin - login Button click event
 * @param {string} loginText - login Button Text
 * @param {string} onSignup - signup Button click event
 * @param {string} signupText - signup Button TExt
 * @returns
 */
function LoginBtns({ onLogin, loginText, onSignup, signupText }) {
  return (
    <Stack spacing={1}>
      <Button
        variant="contained"
        id="LoginBtn"
        style={{ backgroundColor: '#1a9ef8' }}
        fullWidth
        size="large"
        type="submit"
        onClick={onLogin}
      >
        {loginText}
      </Button>
      <Button
        variant="contained"
        id="SignupBtn"
        style={{ backgroundColor: 'white', color: 'black', border: '1px solid #ddd' }}
        fullWidth
        size="large"
        type="submit"
        onClick={onSignup}
      >
        {signupText}
      </Button>
    </Stack>
  );
}

const Button = styled(LoadingButton)({
  boxShadow: 'none',
});

export default LoginBtns;
